import {
  GridActionsCellItem,
  GridColDef,
  GridRowParams,
} from '@mui/x-data-grid-pro';

export const getRemoveActionActTableCell = (
  onDelete: (id: string) => void,
): GridColDef => ({
  field: 'actions',
  type: 'actions',
  width: 50,
  getActions: (params: GridRowParams) => {
    return [
      <GridActionsCellItem
        onClick={() => onDelete(params.row.id)}
        label='Видалити'
        showInMenu
      />,
    ];
  },
});
